import { useResolveNavigate } from '../../hooks/use-resolve-navigate'
import { Button } from '../ui/button-comp'
import { useHeaderStore } from './header-store'

export function HeaderActionButton() {
	const headerActionButtonText = useHeaderStore((state) => state.headerActionButtonText)
	const headerActionButtonLocation = useHeaderStore((state) => state.headerActionButtonLocation)
	const resolveNavigate = useResolveNavigate()

	// Check if we're in a form context by using useContext directly

	const handleClick = () => {
		resolveNavigate({ path: headerActionButtonLocation })
	}

	return (
		<Button
			className={``}
			variant={'default'}
			onClick={handleClick}>
			{headerActionButtonText}
		</Button>
	)
}
